import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { UserModule } from '@app/user/user.module';
import { PathwayAddEditFormModalComponent } from './pathway-add-edit-form-modal.component';
import { TagsModule } from '@app/tags/tags.module';
import { UploaderModule } from '@app/uploader/uploader.module';
import { DfLabelMarkerModule } from '@lib/fresco';

@NgModule({
  declarations: [PathwayAddEditFormModalComponent],
  exports: [],
  imports: [
    SharedModule,
    TagsModule,
    UserModule,
    UploaderModule,
    DfLabelMarkerModule,
  ],
})
export class PathwayAddEditFormModule {}
